import { EventDispatcher, addEventListeners, getCookie, getUrlVars, logEvent, qsa, sleep } from '@utils/toolbox';
import { body, footer } from './templates';
import { Modal } from '@js/components/modal';
import { eventCategories, events } from '@js/utils/event';
import { ConnectApi } from '@js/plugins/connectApi';

export const KalleBakom = (opts) => {
	let modal;
	let activeRequest = false;
	let kalleBakomResponse = false;
	let timeStarted = null;
	let airportInformation = null;
	const debug = getUrlVars()?.debugKalle;

	const log = (...args) => {
		console.log('[KalleBakom]:', ...args);
	};

	const defaults = {
		onVisibilityChangeDelay: debug ? 0 : js_params.kalleBakomDelay
	};

	const options = {
		...defaults,
		...opts
	};

	async function startRequest (kallebakomRequest, prerequestDelay = 5000) {
		log('Queuing request');

		activeRequest = true;
		if (debug && debug !== 'true') {
			kallebakomRequest.push(debug);
		}
		await sleep(prerequestDelay);
		log('Request started');
		kalleBakomResponse = await ConnectApi('Kallebakom', 'getKallebakoms', kallebakomRequest);
		log('Request finished');
	}


	function visibilityChangeHandler () {
		return function () {
			if (document.hidden) {
				return;
			}

			// Calculate time elapsed since the request started
			const timeElapsed = new Date().getTime() - timeStarted;
			if (timeElapsed > options.onVisibilityChangeDelay && activeRequest) {
				log('Tab is visible after delay, opening modal');
				showModal();
				return;
			}

			if (activeRequest) {
				activeRequest = false;
				removeEventListener();
				log('Tab is visible, but time elapsed is less than delay, cancelling request');
			}
		};
	}

	let visibilityChangeEventHandler;

	async function display ({ airportInformation: _airportInformation, kallebakomRequest }) {
		airportInformation = _airportInformation || null;
		timeStarted = new Date().getTime();

		if (getCookie('CYPRESS_ENABLED') || debug) {
			await startRequest(kallebakomRequest, 0);
			showModal();
			return;
		}

		if (activeRequest) {
			log('Request already in progress, cancelling new request');
			return;
		}

		visibilityChangeEventHandler = visibilityChangeHandler();
		document.addEventListener('visibilitychange', visibilityChangeEventHandler);

		try {
			await startRequest(kallebakomRequest, 2000);
		} catch (err) {
			log('API failed', err);
			activeRequest = false;
			removeEventListener();
		}
	}


	function removeEventListener () {
		document.removeEventListener('visibilitychange', visibilityChangeEventHandler);
	}

	function destroy () {
		removeEventListener();
		activeRequest = false;
		modal.destroy();
	}

	const showModal = () => {
		let footerContent = '';
		let offerId = '';

		if (!kalleBakomResponse?.length) {
			log('Response is falsey', kalleBakomResponse);
			return;
		}

		const selectedOffer = kalleBakomResponse.find(offer => offer.selected);

		if (!selectedOffer) {
			log('No selected offer found');
			return;
		}

		footerContent = footer(selectedOffer.id, selectedOffer.forwardURL);
		offerId = selectedOffer.id;

		const analyticsEventMap = {
			bookingcom: events.kalleBakomClickBooking,
			rentalcar: events.kalleBakomClickRentalCar,
			airporttransfer: events.kalleBakomClickAirportTransfer,
			forex: events.kalleBakomClickForex,
			arlandaexpress: events.kalleBakomClickArlandaExpress,
			airalo: events.kalleBakomClickAiralo
		};

		modal = new Modal({
			id: 'kallebakomModal',
			className: `kallebakom offers${kalleBakomResponse.length} ${offerId}`,
			hideFooter: false,
			hideHeader: true,
			hideOnSwipe: false,
			resetScroll: true,
			footer: footerContent,
			// header: headerContent,
			body: body(airportInformation, kalleBakomResponse),
			onOpen: () => {
				addEventListeners(qsa('.kallebakom_cta'), 'click', (e) => {
					if (e.target.getAttribute('data-url')) {
						const analyticsEvent = analyticsEventMap[e.target.getAttribute('data-kalleid')];
						logEvent(analyticsEvent, eventCategories.kallebakom, { target: 'model-cta' });
						window.open(e.target.getAttribute('data-url'), '_blank');
					} else {
						console.warn('No url found');
					}
				});
				addEventListeners(qsa('.link-item'), 'click', (e) => {
					const analyticsEvent = analyticsEventMap[e.target.closest('a').getAttribute('data-kalleid')];
					logEvent(analyticsEvent, eventCategories.kallebakom, { target: 'extra-item' });
				});
			},
			onClose: () => {
				EventDispatcher.dispatch('kalleBakom:modalClosed');
				destroy();
			},
			...options.modalOptions
		});

		modal.open();

		logEvent(events.observeKallebakom, eventCategories.observe);
		removeEventListener();
		activeRequest = false;
	};

	return {
		display,
		destroy
	};
};
